module.exports = __webpack_public_path__ + "img/banner.65a8edd4.png";